import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Store, User, Mail, Phone, Lock, Briefcase, CheckCircle2 } from 'lucide-react';
import { useNavigation } from '../context/NavigationContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function VendorSignupScreen() {
  const {
    navigate
  } = useNavigation();
  const [formData, setFormData] = useState({
    storeName: '',
    fullName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    businessType: 'Individual',
    agreed: false
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.agreed) {
      navigate(Screen.VENDOR_VERIFY);
    }
  };
  return <div className="min-h-full bg-gray-50 dark:bg-gray-900 pb-10" data-id="element-2367">
      <Header title="Seller Registration" showBack data-id="element-2368" />

      <div className="p-6" data-id="element-2369">
        <div className="mb-8 text-center" data-id="element-2370">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2371">
            <Store className="w-8 h-8 text-primary" data-id="element-2372" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-2373">
            Join JUMMALL
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-1" data-id="element-2374">
            Start selling to millions of customers
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-2375">
          <div data-id="element-2376">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2377">
              Store Name
            </label>
            <div className="relative" data-id="element-2378">
              <Store className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2379" />
              <input type="text" required className="w-full pl-10 pr-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent dark:text-white" placeholder="e.g. Kingsley Electronics" value={formData.storeName} onChange={e => setFormData({
              ...formData,
              storeName: e.target.value
            })} data-id="element-2380" />
            </div>
          </div>

          <div data-id="element-2381">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2382">
              Owner Full Name
            </label>
            <div className="relative" data-id="element-2383">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2384" />
              <input type="text" required className="w-full pl-10 pr-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent dark:text-white" placeholder="John Doe" value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} data-id="element-2385" />
            </div>
          </div>

          <div data-id="element-2386">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2387">
              Email Address
            </label>
            <div className="relative" data-id="element-2388">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2389" />
              <input type="email" required className="w-full pl-10 pr-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent dark:text-white" placeholder="john@example.com" value={formData.email} onChange={e => setFormData({
              ...formData,
              email: e.target.value
            })} data-id="element-2390" />
            </div>
          </div>

          <div data-id="element-2391">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2392">
              Phone Number
            </label>
            <div className="relative" data-id="element-2393">
              <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2394" />
              <input type="tel" required className="w-full pl-10 pr-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent dark:text-white" placeholder="+234 800 000 0000" value={formData.phone} onChange={e => setFormData({
              ...formData,
              phone: e.target.value
            })} data-id="element-2395" />
            </div>
          </div>

          <div data-id="element-2396">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2397">
              Business Type
            </label>
            <div className="relative" data-id="element-2398">
              <Briefcase className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2399" />
              <select className="w-full pl-10 pr-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent dark:text-white appearance-none" value={formData.businessType} onChange={e => setFormData({
              ...formData,
              businessType: e.target.value
            })} data-id="element-2400">
                <option value="Individual" data-id="element-2401">Individual / Freelancer</option>
                <option value="Registered" data-id="element-2402">Registered Business (CAC)</option>
              </select>
            </div>
          </div>

          <div data-id="element-2403">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2404">
              Password
            </label>
            <div className="relative" data-id="element-2405">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2406" />
              <input type="password" required className="w-full pl-10 pr-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent dark:text-white" placeholder="••••••••" value={formData.password} onChange={e => setFormData({
              ...formData,
              password: e.target.value
            })} data-id="element-2407" />
            </div>
          </div>

          <label className="flex items-start gap-3 mt-6" data-id="element-2408">
            <input type="checkbox" required checked={formData.agreed} onChange={e => setFormData({
            ...formData,
            agreed: e.target.checked
          })} className="mt-1 w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary" data-id="element-2409" />
            <span className="text-sm text-gray-600 dark:text-gray-400" data-id="element-2410">
              I agree to JUMMALL's{' '}
              <span className="text-primary font-medium" data-id="element-2411">
                Seller Terms & Conditions
              </span>{' '}
              and{' '}
              <span className="text-primary font-medium" data-id="element-2412">Privacy Policy</span>.
            </span>
          </label>

          <div className="pt-4" data-id="element-2413">
            <Button type="submit" className="w-full bg-primary hover:bg-primary/90 text-white py-4 rounded-xl font-semibold" data-id="element-2414">
              Create Seller Account
            </Button>
          </div>
        </form>

        <p className="text-center mt-6 text-gray-600 dark:text-gray-400" data-id="element-2415">
          Already have a seller account?{' '}
          <button onClick={() => navigate(Screen.LOGIN)} className="text-accent font-semibold" data-id="element-2416">
            Login
          </button>
        </p>
      </div>
    </div>;
}